import { Link } from "react-router-dom";
import { Wrench, Zap, Cog, Gauge, ShieldCheck, Battery, ArrowRight } from "lucide-react";

const SECTIONS = [
  { icon: Wrench, t: "Forklift Breakdown Repairs", d: "Fault finding and repair for forklifts that won't start, won't drive, won't lift correctly or have developed mechanical or electrical problems." },
  { icon: Cog, t: "Engine & LPG Repairs", d: "Engine fault diagnosis, spark plugs, ignition, LPG regulators, cooling systems, rocker cover leaks, water pumps, timing components, fuel issues and full engine servicing." },
  { icon: Gauge, t: "Hydraulic Repairs", d: "Hydraulic leaks, lift/tilt/steering cylinders, hoses, seals, hydraulic pumps and mast/carriage issues." },
  { icon: ShieldCheck, t: "Brakes", d: "Brake inspections, shoes, wheel cylinders, brake adjustment, master cylinders, parking brakes and brake fault diagnosis." },
  { icon: Zap, t: "Electrical Diagnostics", d: "Charging systems, starter motors, alternators, sensors, switches, wiring faults, safety circuits, lighting and battery issues." },
  { icon: Wrench, t: "Mast & Carriage Repairs", d: "Chains, rollers, wear pads, mast lubrication, carriage adjustment, broken bolts, attachments and forks." },
  { icon: Battery, t: "Electric Forklifts & Reach Trucks", d: "Battery inspection, charging faults, electrical diagnosis, safety switches, drive issues, hydraulic systems and steering faults." },
];

export default function Service() {
  return (
    <div>
      <section className="bg-[#111111] text-white">
        <div className="max-w-7xl mx-auto px-6 py-20 ff-diagonal-bg">
          <div className="text-xs uppercase tracking-widest text-[#D71920] font-bold">Service & Repairs</div>
          <h1 className="font-display text-5xl md:text-7xl uppercase mt-3">Forklift service & repairs Brisbane</h1>
          <p className="mt-5 max-w-3xl text-white/75 text-lg">Forkfix provides professional mobile forklift servicing, fault diagnosis and repairs for businesses across Brisbane. Our mobile workshop allows many repairs to be completed directly at the customer's site, helping reduce transport requirements and equipment downtime.</p>
          <Link to="/book-service" className="ff-btn-primary mt-8" data-testid="svc-hero-book"><Wrench className="w-4 h-4" /> Book a Technician</Link>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 gap-px bg-[#e5e5e5] border border-[#e5e5e5]">
          {SECTIONS.slice(0, 4).map(({ icon: I, t, d }) => (
            <div key={t} className="bg-white p-8">
              <I className="w-7 h-7 text-[#D71920]" />
              <h2 className="font-display text-2xl uppercase mt-4">{t}</h2>
              <p className="text-sm text-[#555] mt-3">{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#D71920] text-white">
        <div className="max-w-7xl mx-auto px-6 py-14 flex flex-wrap items-center justify-between gap-6">
          <div>
            <h2 className="font-display text-3xl md:text-4xl uppercase">Need a technician?</h2>
            <p className="mt-2 text-white/90 max-w-xl">Book a service request online. Upload photos and provide your forklift details so we can better prepare for the job before attending your site.</p>
          </div>
          <Link to="/book-service" className="inline-flex items-center gap-2 bg-black text-white px-6 py-4 text-sm uppercase tracking-widest font-bold hover:bg-white hover:text-black" data-testid="svc-mid-cta">Start Service Booking <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 gap-px bg-[#e5e5e5] border border-[#e5e5e5]">
          {SECTIONS.slice(4).map(({ icon: I, t, d }) => (
            <div key={t} className="bg-white p-8">
              <I className="w-7 h-7 text-[#D71920]" />
              <h2 className="font-display text-2xl uppercase mt-4">{t}</h2>
              <p className="text-sm text-[#555] mt-3">{d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
